import KaartViewerApi from '@/services/Api/KaartViewerApi'

export default {
  all () {
    return KaartViewerApi().get('/menu?time=' + new Date().getTime())
  },
  background () {
    return KaartViewerApi().get('/menu/background?time=' + new Date().getTime())
  },
  announcement () {
    return KaartViewerApi().get('/menu/announcement?time=' + new Date().getTime())
  }
}
